/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class CustomTagsInner {
  'key': string;
  'value': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "key",
      "baseName": "key",
      "type": "string",
      "format": ""
    },
    {
      "name": "value",
      "baseName": "value",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CustomTagsInner.attributeTypeMap;
  }

  public constructor() {
  }
}

